import { styled } from '@mui/material/styles';

import type { SwitchSize } from './types';

export const SwitchContainer = styled('button')<{
	checked: boolean;
	size: SwitchSize;
}>(({ theme, checked, size, disabled }) => {
	const isSmall = size === 'small';

	return {
		all: 'unset',
		position: 'relative',
		width: isSmall ? 48 : 64,
		height: isSmall ? 24 : 32,
		borderRadius: 28,
		backgroundColor:
			checked && !disabled
				? theme.palette.primary.main
				: theme.palette?.solutions?.[100],
		cursor: disabled ? 'not-allowed' : 'pointer',
		transition: 'background-color 0.3s ease, border-color 0.3s ease',
	};
});

export const Thumb = styled('span')<{
	checked: boolean;
	size: SwitchSize;
}>(({ theme, checked, size }) => {
	const isSmall = size === 'small';

	return {
		position: 'absolute',
		borderRadius: '50%',
		background: theme.palette.neutral.main,
		transition:
			'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease',
		width: isSmall ? 19 : 24,
		height: isSmall ? 19 : 24,
		top: isSmall ? 2.5 : 4,
		left: isSmall ? 4 : checked ? 3 : 4,
		transform: checked ? `translateX(${isSmall ? 21 : 32}px)` : 'none',
	};
});
